var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
  Flickity = require('flickity');


function StickyHeader(el) {
  var t = this;

  this.el = el;
  this.$el = $(el);
  let tabs = t.el.querySelectorAll('.sticky-header__item[data-comparison-title]'),
      tabCount = tabs.length;

  $(window).on('scroll', function() {
    var scroll = $(window).scrollTop(),
        headerHeight = $('.header').outerHeight();

    if( scroll > headerHeight ) {
      $('body').addClass('js-stickyheader-active');
    } else {
      $('body').removeClass('js-stickyheader-active');
    }
  });

  t.comparisonList = new Flickity(t.el.querySelector('[data-comparison-titles]'), {
    draggable: true,
    groupCells: true,
    pageDots: false,
    prevNextButtons: false,
    cellAlign: 'center',
    contain: true,
    asNavFor: '[data-tab-content]',
    accessibility: false
  });

  $(window).on('load', function() {
    t.comparisonList.resize();
  });

  Array.prototype.map.call(tabs,(el, index) => {
    const tabList = Array.from(tabs)
    $(el).click(() => {
      t.tabContentCarousel.select(index)
    })

    el.addEventListener('keydown', (e) => {
      if ((e.key === 'ArrowRight' || e.key === 'ArrowDown')) {
        el.setAttribute('tabindex', '-1')
        if (index === tabCount - 1) {
          tabList[0].removeAttribute('tabIndex')
          tabList[0].focus()
        } else {
          tabList[index + 1].tabIndex = 0
          tabList[index + 1].focus()
        }
      }
      if ((e.key === 'ArrowLeft' || e.key === 'ArrowUp')) {
        el.setAttribute('tabindex', '-1')
        if (index === 0) {
          tabList[tabCount - 1].removeAttribute('tabIndex')
          tabList[tabCount - 1].focus()
        } else {
          tabList[index - 1].removeAttribute('tabIndex')
          tabList[index - 1].focus()
        }
      }
    })
  })
}

module.exports = StickyHeader;
